import { render, staticRenderFns } from "./vip-exam.vue?vue&type=template&id=993fb5a4&scoped=true&"
import script from "./vip-exam.vue?vue&type=script&lang=js&"
export * from "./vip-exam.vue?vue&type=script&lang=js&"
import style0 from "./vip-exam.vue?vue&type=style&index=0&id=993fb5a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993fb5a4",
  null
  
)

export default component.exports